// extracted by mini-css-extract-plugin
export default {"ReturnLink":"ReturnLink_ReturnLink__67WLZ","ReturnLink__Text":"ReturnLink_ReturnLink__Text__ZuzQz"};